export default list => {
  const items = list
    .map(item => {
      return `<li class="btn" title="copy" data-clipboard-text="[${item.personalizationTag}]">
              <span>${item.personalizationTag} </span><i class="fa fa-copy"></i>
            </li>`
    })
    .join('')

  return `<ul class="field-list">${items}</ul>`
}
